import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { PortalAuthService } from '../auth/portal-auth.service';

export const portalGuestGuard: CanActivateFn = () => {
  const auth = inject(PortalAuthService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  return auth.mustChangePassword()
    ? router.createUrlTree(['/cliente/account/security'])
    : router.createUrlTree(['/cliente']);
};
